import React from 'react';
import { Card } from 'antd';
import TableSplitCompensationTab from './components/TableSplitCompensationTab';

const TableSplitCompensationPage: React.FC = () => {
  return (
    <Card title="大表拆分补偿工具" bordered={false}>
      <TableSplitCompensationTab />
    </Card>
  );
};

export default TableSplitCompensationPage;
